import type { UserDto } from "@/dto";
import { useApi } from "@/services/api";

const CACHE_EXPIRATION_TIME = 1000 * 60 * 60; // 1 hour

interface CacheEntry {
  user: UserDto;
  expiresAt: Date;
}
const _cache = new Map<string, CacheEntry>();

export function useUsers() {
  const _api = useApi();

  async function getUser(id: string) {
    if (_cache.has(id)) {
      const entry = _cache.get(id);
      if (entry && entry.expiresAt > new Date()) {
        return entry.user;
      }
    }
    const user = await _api.fetchUser(id);
    if (user) {
      _cache.set(id, { user, expiresAt: new Date(Date.now() + CACHE_EXPIRATION_TIME) });
      return user;
    }
  }

  return {
    getUser,
  };
}
